
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/flamingo/page/[id]",
      function () {
        return require("private-next-pages/cases/flamingo/page/[id].tsx");
      }
    ]);
  